import React, { useState, useEffect } from "react";

// Updated resources with consistent WordPress wp-content/uploads paths
const resources = {
  brochure: {
    Brochure: [
      {
        title: "BROCHURE 2025-26.pdf",
        file: "/files/Brochure/BROCHURE%202025-26.pdf"
      },
    ],
  },

  mpsc: {
    Syllabus: [
      {
        title: "RAJYASEVA_ NEW_SYLLABUS_MARATHI.pdf",
        file: "/files/MPSC/Syllabus/RAJYASEVA_%20NEW_SYLLABUS_MARATHI.pdf"
      },
      {
        title: "STATE SERVICE NEW SYLLABUS ENGLISH.pdf",
        file: "/files/MPSC/Syllabus/STATE%20SERVICE%20NEW%20SYLLABUS%20ENGLISH.pdf"
      },
    ],
    "Demo Test (Free)": [
      { title: "2021 PAPER 1 MPSC.pdf", file: "/files/MPSC/2021%20PAPER%201%20MPSC.pdf" },
      { title: "2021 PAPER 2 MPSC.pdf", file: "/files/MPSC/2021%20PAPER%202%20MPSC.pdf" },
      { title: "2022 PAPER 1 MPSC.pdf", file: "/files/MPSC/2022%20PAPER%201%20MPSC.pdf" },
      { title: "2022 PAPER 2 MPSC.pdf", file: "/files/MPSC/2022%20PAPER%202%20MPSC.pdf" },
      { title: "2023 PAPER 1 MPSC.pdf", file: "/files/MPSC/2023%20PAPER%201%20MPSC.pdf" },
      { title: "2023 PAPER 2 MPSC.pdf", file: "/files/MPSC/2023%20PAPER%202%20MPSC.pdf" },
      { title: "2024 PAPER 1 MPSC.pdf", file: "/files/MPSC/2024%20PAPER%201%20MPSC.pdf" },
      { title: "2024 PAPER 2 MPSC.pdf", file: "/files/MPSC/2024%20PAPER%202%20MPSC.pdf" },
    ],
    "Mains Practice Questions": [
      { title: "2021 PAPER 1 MPSC.pdf", file: "/files/MPSC/2021%20PAPER%201%20MPSC.pdf" },
      { title: "2021 PAPER 2 MPSC.pdf", file: "/files/MPSC/2021%20PAPER%202%20MPSC.pdf" },
      { title: "2022 PAPER 1 MPSC.pdf", file: "/files/MPSC/2022%20PAPER%201%20MPSC.pdf" },
      { title: "2022 PAPER 2 MPSC.pdf", file: "/files/MPSC/2022%20PAPER%202%20MPSC.pdf" },
      { title: "2023 PAPER 1 MPSC.pdf", file: "/files/MPSC/2023%20PAPER%201%20MPSC.pdf" },
      { title: "2023 PAPER 2 MPSC.pdf", file: "/files/MPSC/2023%20PAPER%202%20MPSC.pdf" },
      { title: "2024 PAPER 1 MPSC.pdf", file: "/files/MPSC/2024%20PAPER%201%20MPSC.pdf" },
      { title: "2024 PAPER 2 MPSC.pdf", file: "/files/MPSC/2024%20PAPER%202%20MPSC.pdf" },
    ],
    "Prelims PYQ": [
      { title: "2021 PAPER 1 MPSC.pdf", file: "/files/MPSC/2021%20PAPER%201%20MPSC.pdf" },
      { title: "2021 PAPER 2 MPSC.pdf", file: "/files/MPSC/2021%20PAPER%202%20MPSC.pdf" },
      { title: "2022 PAPER 1 MPSC.pdf", file: "/files/MPSC/2022%20PAPER%201%20MPSC.pdf" },
      { title: "2022 PAPER 2 MPSC.pdf", file: "/files/MPSC/2022%20PAPER%202%20MPSC.pdf" },
      { title: "2023 PAPER 1 MPSC.pdf", file: "/files/MPSC/2023%20PAPER%201%20MPSC.pdf" },
      { title: "2023 PAPER 2 MPSC.pdf", file: "/files/MPSC/2023%20PAPER%202%20MPSC.pdf" },
      { title: "2024 PAPER 1 MPSC.pdf", file: "/files/MPSC/2024%20PAPER%201%20MPSC.pdf" },
      { title: "2024 PAPER 2 MPSC.pdf", file: "/files/MPSC/2024%20PAPER%202%20MPSC.pdf" },
    ],
  },

  upsc: {
    SYLLABUS: [
      {
        title: "UPSC SYLLABUS.docx",
        file: "/files/UPSC/SYLLABUS/UPSC%20SYLLABUS.docx"
      },
      {
        title: "upsc_notification_2025.pdf",
        file: "/files/UPSC/SYLLABUS/upsc_notification_2025.pdf"
      },
    ],
    PRELIMS: [
      { title: "GENERAL STUDIES PAPER I 2022.pdf", file: "/files/UPSC/PRELIMS/GENERAL%20STUDIES%20PAPER%20I%202022.pdf" },
      { title: "GENERAL STUDIES PAPER II 2022.pdf", file: "/files/UPSC/PRELIMS/GENERAL%20STUDIES%20PAPER%20II%202022.pdf" },
      { title: "QP-CSP-24-GENERAL-STUDIES-PAPER-I-180624.pdf", file: "/files/UPSC/PRELIMS/QP-CSP-24-GENERAL-STUDIES-PAPER-I-180624.pdf" },
      { title: "QP-CSP-24-GENERAL-STUDIES-PAPER-II-180624.pdf", file: "/files/UPSC/PRELIMS/QP-CSP-24-GENERAL-STUDIES-PAPER-II-180624.pdf" },
      { title: "QP-CSP-25-GENERAL-STUDIES-PAPER-I-26052025.pdf", file: "/files/UPSC/PRELIMS/QP-CSP-25-GENERAL-STUDIES-PAPER-I-26052025.pdf" },
      { title: "QP-CSP-25-GENERAL-STUDIES-PAPER-II-26052025.pdf", file: "/files/UPSC/PRELIMS/QP-CSP-25-GENERAL-STUDIES-PAPER-II-26052025.pdf" },
      { title: "QP_CS_Pre_Exam_2023_280523.pdf", file: "/files/UPSC/PRELIMS/QP_CS_Pre_Exam_2023_280523.pdf" },
      { title: "QP_CS_Pre_Exam_2023_GENERAL_STUDIES_PAPER_II_280523.pdf", file: "/files/UPSC/PRELIMS/QP_CS_Pre_Exam_2023_GENERAL_STUDIES_PAPER_II_280523.pdf" },
    ],
    ESSAY: [
      { title: "QP-CSM-22-ESSAY-190922.pdf", file: "/files/UPSC/ESSAY/QP-CSM-22-ESSAY-190922.pdf" },
      { title: "QP-CSM-23-ESSAY-180923.pdf", file: "/files/UPSC/ESSAY/QP-CSM-23-ESSAY-180923.pdf" },
      { title: "QP_CSM_2024_ESSAY_03102024.pdf", file: "/files/UPSC/ESSAY/QP_CSM_2024_ESSAY_03102024.pdf" },
    ],
    MAINS: {
      "GS 2022": [
        { title: "QP-CSM-22-GENERAL-STUDIES-PAPER I-190922.pdf", file: "/files/UPSC/MAINS/GS%202022/QP-CSM-22-GENERAL-STUDIES-PAPER%20I-190922.pdf" },
        { title: "QP-CSM-22-GENERAL-STUDIES-PAPER-II-190922.pdf", file: "/files/UPSC/MAINS/GS%202022/QP-CSM-22-GENERAL-STUDIES-PAPER-II-190922.pdf" },
        { title: "QP-CSM-22-GENERAL-STUDIES-PAPER-III-190922.pdf", file: "/files/UPSC/MAINS/GS%202022/QP-CSM-22-GENERAL-STUDIES-PAPER-III-190922.pdf" },
        { title: "QP-CSM-22-GENERAL-STUDIES-PAPER IV-190922.pdf", file: "/files/UPSC/MAINS/GS%202022/QP-CSM-22-GENERAL-STUDIES-PAPER%20IV-190922.pdf" },
      ],
      "GS 2023": [
        { title: "QP-CSM-23-GENERAL-STUDIES-PAPER-I-180923.pdf", file: "/files/UPSC/MAINS/GS%202023/QP-CSM-23-GENERAL-STUDIES-PAPER-I-180923.pdf" },
        { title: "QP-CSM-23-GENERAL-STUDIES-PAPER-II-180923.pdf", file: "/files/UPSC/MAINS/GS%202023/QP-CSM-23-GENERAL-STUDIES-PAPER-II-180923.pdf" },
        { title: "QP-CSM-23-GENERAL-STUDIES-PAPER-III-180923.pdf", file: "/files/UPSC/MAINS/GS%202023/QP-CSM-23-GENERAL-STUDIES-PAPER-III-180923.pdf" },
        { title: "QP-CSM-23-GENERAL-STUDIES-PAPER-IV-180923.pdf", file: "/files/UPSC/MAINS/GS%202023/QP-CSM-23-GENERAL-STUDIES-PAPER-IV-180923.pdf" },
      ],
      "GS 2024": [
        { title: "QP_CSM_2024_GenStud_I_03102024.pdf", file: "/files/UPSC/MAINS/GS%202024/QP_CSM_2024_GenStud_I_03102024.pdf" },
        { title: "QP_CSM_2024_GenStud_II_03102024.pdf", file: "/files/UPSC/MAINS/GS%202024/QP_CSM_2024_GenStud_II_03102024.pdf" },
        { title: "QP_CSM_2024_GenStud_III_03102024.pdf", file: "/files/UPSC/MAINS/GS%202024/QP_CSM_2024_GenStud_III_03102024.pdf" },
        { title: "QP_CSM_2024_GenStud_IV_03102024.pdf", file: "/files/UPSC/MAINS/GS%202024/QP_CSM_2024_GenStud_IV_03102024.pdf" },
      ],
    },
    OPTIONAL: {
      AGRI: [
        { title: "QP-CSM-22-AGRICULTURE-PAPER-I-280922.pdf", file: "/files/UPSC/OPTIONAL/AGRI/QP-CSM-22-AGRICULTURE-PAPER-I-280922.pdf" },
        { title: "QP-CSM-22-AGRICULTURE-PAPER-II-280922.pdf", file: "/files/UPSC/OPTIONAL/AGRI/QP-CSM-22-AGRICULTURE-PAPER-II-280922.pdf" },
        { title: "QP-CSM-23-AGRICULTURE-PAPER-I-29092023.pdf", file: "/files/UPSC/OPTIONAL/AGRI/QP-CSM-23-AGRICULTURE-PAPER-I-29092023.pdf" },
        { title: "QP-CSM-23-AGRICULTURE-PAPER-II-29092023.pdf", file: "/files/UPSC/OPTIONAL/AGRI/QP-CSM-23-AGRICULTURE-PAPER-II-29092023.pdf" },
        { title: "QP-CSM-24-AGRICULTURE-PAPER-I-031024.pdf", file: "/files/UPSC/OPTIONAL/AGRI/QP-CSM-24-AGRICULTURE-PAPER-I-031024.pdf" },
        { title: "QP-CSM-24-AGRICULTURE-PAPER-II-031024.pdf", file: "/files/UPSC/OPTIONAL/AGRI/QP-CSM-24-AGRICULTURE-PAPER-II-031024.pdf" },
      ],
      ANTHRO: [
        { title: "QP-CSM-22-ANTHROPOLOGY-PAPER-I-280922.pdf", file: "/files/UPSC/OPTIONAL/ANTHRO/QP-CSM-22-ANTHROPOLOGY-PAPER-I-280922.pdf" },
        { title: "QP-CSM-22-ANTHROPOLOGY-PAPER-II-280922.pdf", file: "/files/UPSC/OPTIONAL/ANTHRO/QP-CSM-22-ANTHROPOLOGY-PAPER-II-280922.pdf" },
        { title: "QP-CSM-23-ANTHROPOLOGY-PAPER-I-29092023.pdf", file: "/files/UPSC/OPTIONAL/ANTHRO/QP-CSM-23-ANTHROPOLOGY-PAPER-I-29092023.pdf" },
        { title: "QP-CSM-23-ANTHROPOLOGY-PAPER-II-29092023.pdf", file: "/files/UPSC/OPTIONAL/ANTHRO/QP-CSM-23-ANTHROPOLOGY-PAPER-II-29092023.pdf" },
        { title: "QP-CSM-24-ANTHROPOLOGY-PAPER-I-031024.pdf", file: "/files/UPSC/OPTIONAL/ANTHRO/QP-CSM-24-ANTHROPOLOGY-PAPER-I-031024.pdf" },
        { title: "QP-CSM-24-ANTHROPOLOGY-PAPER-II-031024.pdf", file: "/files/UPSC/OPTIONAL/ANTHRO/QP-CSM-24-ANTHROPOLOGY-PAPER-II-031024.pdf" },
      ],
      PSIR: [
        { title: "QP-CSM-22-POLITICAL-SCIENCE-AND-INTERNATIONAL-RELATIONS-PAPER-I-280922.pdf", file: "/files/UPSC/OPTIONAL/PSIR/QP-CSM-22-POLITICAL-SCIENCE-AND-INTERNATIONAL-RELATIONS-PAPER-I-280922.pdf" },
        { title: "QP-CSM-22-POLITICAL-SCIENCE-AND-INTERNATIONAL-RELATIONS-PAPER-II-280922.pdf", file: "/files/UPSC/OPTIONAL/PSIR/QP-CSM-22-POLITICAL-SCIENCE-AND-INTERNATIONAL-RELATIONS-PAPER-II-280922.pdf" },
        { title: "QP-CSM-23-POL-SC-IR-PAPER-I-29092023.pdf", file: "/files/UPSC/OPTIONAL/PSIR/QP-CSM-23-POL-SC-IR-PAPER-I-29092023.pdf" },
        { title: "QP-CSM-23-POL-SC-IR-PAPER-II-29092023.pdf", file: "/files/UPSC/OPTIONAL/PSIR/QP-CSM-23-POL-SC-IR-PAPER-II-29092023.pdf" },
        { title: "QP-CSM-24-POLITICAL-SCIENCE-INTERNL -REL-PAPER-I-031024.pdf", file: "/files/UPSC/OPTIONAL/PSIR/QP-CSM-24-POLITICAL-SCIENCE-INTERNL%20-REL-PAPER-I-031024.pdf" },
        { title: "QP-CSM-24-POLITICAL-SCIENCE-INTERNL -REL-PAPER-II-031024.pdf", file: "/files/UPSC/OPTIONAL/PSIR/QP-CSM-24-POLITICAL-SCIENCE-INTERNL%20-REL-PAPER-II-031024.pdf" },
      ],
      "PUB AD": [
        { title: "QP-CSM-22-PUBLIC-ADMINISTRATION-PAPER-I-280922.pdf", file: "/files/UPSC/OPTIONAL/PUB%20AD/QP-CSM-22-PUBLIC-ADMINISTRATION-PAPER-I-280922.pdf" },
        { title: "QP-CSM-22-PUBLIC-ADMINISTRATION-PAPER-II-280922.pdf", file: "/files/UPSC/OPTIONAL/PUB%20AD/QP-CSM-22-PUBLIC-ADMINISTRATION-PAPER-II-280922.pdf" },
        { title: "QP-CSM-23-PUBLIC ADMINISTRATION-PAPER-I-29092023.pdf", file: "/files/UPSC/OPTIONAL/PUB%20AD/QP-CSM-23-PUBLIC%20ADMINISTRATION-PAPER-I-29092023.pdf" },
        { title: "QP-CSM-23-PUBLIC ADMINISTRATION-PAPER-II-29092023.pdf", file: "/files/UPSC/OPTIONAL/PUB%20AD/QP-CSM-23-PUBLIC%20ADMINISTRATION-PAPER-II-29092023.pdf" },
        { title: "QP-CSM-24-PUBLIC-ADMINISTRATION-PAPER-I-031024.pdf", file: "/files/UPSC/OPTIONAL/PUB%20AD/QP-CSM-24-PUBLIC-ADMINISTRATION-PAPER-I-031024.pdf" },
        { title: "QP-CSM-24-PUBLIC-ADMINISTRATION-PAPER-II-031024.pdf", file: "/files/UPSC/OPTIONAL/PUB%20AD/QP-CSM-24-PUBLIC-ADMINISTRATION-PAPER-II-031024.pdf" },
      ],
    },
  },

  capf: {
    Syllabus: [
      {
        title: "SELECTION PROCEDURE SCHEME OF THE EXAMINATION.pdf",
        file: "/files/CAPF/SYLLABUS/SELECTION%20PROCEDURE%20SCHEME%20OF%20THE%20EXAMINATION.pdf"
      },
      {
        title: "SYLLABUS_CAPF.pdf",
        file: "/files/CAPF/SYLLABUS/SYLLABUS_CAPF.pdf"
      },
    ],
  },
  
  books: {
    Science: [
      { title: "6th Science Stateboard Marathi", file: "https://ebooks.ebalbharati.in/pdfs/601020012.pdf" },
      { title: "7th Science Stateboard Marathi", file: "https://ebooks.ebalbharati.in/pdfs/701020012.pdf" },
      { title: "8th Science Stateboard Marathi", file: "https://ebooks.ebalbharati.in/pdfs/801020012.pdf" },
    ],
    History: [
      { title: "6th History Stateboard Marathi", file: "https://ebooks.ebalbharati.in/pdfs/601000584.pdf" },
      { title: "7th History Stateboard Marathi", file: "https://ebooks.ebalbharati.in/pdfs/701000584.pdf" },
    ],
    Geography: [
      { title: "6th Geography Stateboard Marathi", file: "https://ebooks.ebalbharati.in/pdfs/601020011.pdf" },
      { title: "7th Geography Stateboard Marathi", file: "https://ebooks.ebalbharati.in/pdfs/701020011.pdf" },
    ],
  }
};

// Mobile detection utility
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// Simplified and more reliable download function
const downloadFile = async (fileUrl, fileName) => {
  console.log('Opening file directly:', { fileUrl, fileName });

  try {
    // Create a temporary anchor element for download
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.download = fileName;
    
    // For mobile devices or direct download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    console.log('Download/Open initiated successfully');
  } catch (error) {
    console.error('Download failed:', error);
    
    // Fallback: try to open directly
    try {
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    } catch (finalError) {
      console.error('All methods failed:', finalError);
      alert('Unable to open file. Please try again or check your internet connection.');
    }
  }
};

// Icon components
const FolderIcon = ({ className, isOpen }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
      d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" 
    />
  </svg>
);

const FileIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
    />
  </svg>
);

const ChevronIcon = ({ className, isOpen }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
      d={isOpen ? "m19 9-7 7-7-7" : "m9 18 6-6-6-6"} 
    />
  </svg>
);

const EyeIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
);

const DownloadIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
      d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const SearchIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
);

const ExternalLinkIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
  </svg>
);

const getFileIcon = (filename) => {
  const ext = filename.split('.').pop().toLowerCase();
  if (ext === 'pdf') return <FileIcon className="w-4 h-4 text-red-500" />;
  if (ext === 'docx') return <FileIcon className="w-4 h-4 text-blue-500" />;
  return <FileIcon className="w-4 h-4 text-gray-500" />;
};

// Search function
const searchInData = (data, searchTerm) => {
  if (!searchTerm) return data;
  
  const lowerSearchTerm = searchTerm.toLowerCase();
  
  if (Array.isArray(data)) {
    return data.filter(file => 
      file.title.toLowerCase().includes(lowerSearchTerm)
    );
  }
  
  if (typeof data === 'object' && data !== null) {
    const filtered = {};
    Object.entries(data).forEach(([key, value]) => {
      const filteredValue = searchInData(value, searchTerm);
      if (
        key.toLowerCase().includes(lowerSearchTerm) ||
        (Array.isArray(filteredValue) && filteredValue.length > 0) ||
        (typeof filteredValue === 'object' && Object.keys(filteredValue).length > 0)
      ) {
        filtered[key] = filteredValue;
      }
    });
    return filtered;
  }
  
  return data;
};

const FileNode = ({ file, searchTerm }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const isHighlighted = searchTerm && file.title.toLowerCase().includes(searchTerm.toLowerCase());
  
  const handleFileClick = () => {
    console.log('Opening file:', file.file);
    window.open(file.file, '_blank', 'noopener,noreferrer');
  };

  const handleViewClick = (e) => {
    e.stopPropagation();
    setIsProcessing(true);
    console.log('Viewing file:', file.file);
    window.open(file.file, '_blank', 'noopener,noreferrer');
    setTimeout(() => setIsProcessing(false), 1000);
  };
  
  const handleDownload = async (e) => {
    e.stopPropagation();
    setIsProcessing(true);
    
    try {
      await downloadFile(file.file, file.title);
    } catch (error) {
      console.error('Download error:', error);
      alert('Unable to download file. It will open in a new tab instead.');
      window.open(file.file, '_blank', 'noopener,noreferrer');
    } finally {
      setTimeout(() => setIsProcessing(false), 1000);
    }
  };
  
  return (
    <div className={`group flex items-center gap-3 pl-8 py-3 text-sm hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 rounded-lg transition-all duration-200 border-l-2 border-transparent hover:border-l-blue-400 mx-2 ${isHighlighted ? 'bg-yellow-50 border-l-yellow-400' : ''}`}>
      {getFileIcon(file.title)}
      <span 
        className={`flex-1 text-gray-700 group-hover:text-gray-900 font-medium truncate cursor-pointer ${isHighlighted ? 'bg-yellow-200 px-1 rounded' : ''}`} 
        title={file.title}
        onClick={handleFileClick}
      >
        {file.title}
      </span>
      
      {/* File status indicator */}
      <div className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded flex items-center gap-1">
        <ExternalLinkIcon className="w-3 h-3" />
        Online
      </div>

      <div className={`flex gap-2 ${isMobile() ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'} transition-opacity duration-200`}>
        <button
          onClick={handleViewClick}
          disabled={isProcessing}
          className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-100 rounded-md transition-colors disabled:opacity-50"
          title="Open in new tab"
        >
          {isProcessing ? (
            <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          ) : (
            <EyeIcon className="w-4 h-4" />
          )}
        </button>
        <button
          onClick={handleDownload}
          disabled={isProcessing}
          className="p-1.5 text-gray-400 hover:text-green-600 hover:bg-green-100 rounded-md transition-colors disabled:opacity-50"
          title="Download/Open file"
        >
          {isProcessing ? (
            <div className="w-4 h-4 border-2 border-green-600 border-t-transparent rounded-full animate-spin"></div>
          ) : (
            <DownloadIcon className="w-4 h-4" />
          )}
        </button>
      </div>
    </div>
  );
};

const FolderNode = ({ name, data, level = 0, isRoot = false, searchTerm, selectedFilter }) => {
  const shouldBeOpen = () => {
    if (isRoot && selectedFilter !== "all") {
      return name.toLowerCase().includes(selectedFilter.toLowerCase());
    }
    return isRoot || !!searchTerm;
  };

  const [isOpen, setIsOpen] = useState(shouldBeOpen());
  
  useEffect(() => {
    if (isRoot && selectedFilter !== "all") {
      const shouldOpen = name.toLowerCase().includes(selectedFilter.toLowerCase());
      setIsOpen(shouldOpen);
    } else if (isRoot || !!searchTerm) {
      setIsOpen(true);
    }
  }, [selectedFilter, searchTerm, isRoot, name]);
  
  const toggle = () => setIsOpen(!isOpen);
  
  const getBgColor = () => {
    if (isRoot) {
      if (name.toLowerCase().includes('upsc')) return 'bg-gradient-to-r from-blue-100 to-blue-50 border-blue-200';
      if (name.toLowerCase().includes('mpsc')) return 'bg-gradient-to-r from-green-100 to-green-50 border-green-200';
      if (name.toLowerCase().includes('brochure')) return 'bg-gradient-to-r from-purple-100 to-purple-50 border-purple-200';
      if (name.toLowerCase().includes('books')) return 'bg-gradient-to-r from-yellow-100 to-yellow-50 border-yellow-200';
      if (name.toLowerCase().includes('capf')) return 'bg-gradient-to-r from-red-100 to-red-50 border-red-200';
    }
    return 'bg-white hover:bg-gray-50 border-gray-200';
  };

  const getFileCount = (data) => {
    if (Array.isArray(data)) {
      return data.length;
    }
    if (typeof data === 'object' && data !== null) {
      return Object.values(data).reduce((count, subData) => count + getFileCount(subData), 0);
    }
    return 0;
  };

  const fileCount = getFileCount(data);
  const isHighlighted = searchTerm && name.toLowerCase().includes(searchTerm.toLowerCase());

  return (
    <div className={`${level > 0 ? 'ml-4' : ''} mb-2`}>
      <div
        className={`flex items-center cursor-pointer gap-3 py-3 px-4 rounded-xl border transition-all duration-300 hover:shadow-md ${getBgColor()} ${isRoot ? 'shadow-sm' : ''} ${isHighlighted ? 'ring-2 ring-yellow-300' : ''}`}
        onClick={toggle}
      >
        <div className="flex items-center gap-2">
          <ChevronIcon className="w-5 h-5 text-gray-600" isOpen={isOpen} />
          <FolderIcon className="w-5 h-5 text-amber-500" isOpen={isOpen} />
        </div>
        <span className={`font-semibold ${isRoot ? 'text-lg text-gray-800' : 'text-base text-gray-700'} uppercase tracking-wide ${isHighlighted ? 'bg-yellow-200 px-1 rounded' : ''}`}>
          {name}
        </span>
        {fileCount > 0 && (
          <span className="ml-auto bg-gray-200 text-gray-600 text-xs px-2 py-1 rounded-full font-medium">
            {fileCount} files
          </span>
        )}
      </div>

      {isOpen && (
        <div className={`mt-2 ${isRoot ? 'bg-white rounded-lg border border-gray-100 shadow-sm' : ''} transition-all duration-300 ease-in-out`}>
          {Array.isArray(data)
            ? data.map((file, index) => (
                <FileNode key={index} file={file} searchTerm={searchTerm} />
              ))
            : Object.entries(data).map(([subName, subData], index) => (
                <FolderNode
                  key={index}
                  name={subName}
                  data={subData}
                  level={level + 1}
                  isRoot={false}
                  searchTerm={searchTerm}
                  selectedFilter={selectedFilter}
                />
              ))}
        </div>
      )}
    </div>
  );
};

const StatusBar = () => {
  const [connectionStatus, setConnectionStatus] = useState('checking');

  useEffect(() => {
    // Check connection to the file server
    const testConnection = async () => {
      try {
        // Test with a simple HEAD request to one of the files
        const testUrl = 'https://dimensionias.com/cms/wp-content/uploads/pdfs/brochure/BROCHURE-2025-26.pdf';
        const response = await fetch(testUrl, { 
          method: 'HEAD',
          mode: 'no-cors' // This will always succeed but we can't check the actual response
        });
        setConnectionStatus('online');
      } catch (error) {
        console.log('Connection test:', error);
        setConnectionStatus('online'); // Assume online since we can't really test with no-cors
      }
    };

    testConnection();
  }, []);

  return (
    <div className="bg-white border-t border-gray-200 px-4 py-2 flex items-center justify-between text-xs text-gray-500">
      <div className="flex items-center gap-2">
        <div className={`w-2 h-2 rounded-full ${connectionStatus === 'online' ? 'bg-green-500' : 'bg-red-500'}`}></div>
        <span>File Server: {connectionStatus}</span>
      </div>
      <div className="flex items-center gap-4">
        <span>Total Resources: {Object.values(resources).reduce((total, category) => {
          if (typeof category === 'object') {
            return total + Object.values(category).reduce((subTotal, subCategory) => {
              if (Array.isArray(subCategory)) {
                return subTotal + subCategory.length;
              } else if (typeof subCategory === 'object') {
                return subTotal + Object.values(subCategory).reduce((deepTotal, deepCategory) => {
                  return deepTotal + (Array.isArray(deepCategory) ? deepCategory.length : 0);
                }, 0);
              }
              return subTotal;
            }, 0);
          }
          return total;
        }, 0)}</span>
        <span>Last Updated: Aug 2025</span>
      </div>
    </div>
  );
};

const ResourceExplorer = ({ initialCategory = null }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("all");

  useEffect(() => {
    if (initialCategory) {
      setSelectedFilter(initialCategory.toLowerCase());
    }
  }, [initialCategory]);

  const handleFilterChange = (newFilter) => {
    setSelectedFilter(newFilter);
  };

  const filteredResources = Object.entries(resources)
    .reduce((acc, [name, data]) => {
      if (selectedFilter !== "all" && !name.toLowerCase().includes(selectedFilter)) {
        return acc;
      }
      
      const searchFiltered = searchInData(data, searchTerm);
      if (
        !searchTerm ||
        name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (Array.isArray(searchFiltered) && searchFiltered.length > 0) ||
        (typeof searchFiltered === 'object' && Object.keys(searchFiltered).length > 0)
      ) {
        acc[name] = searchFiltered;
      }
      return acc;
    }, {});

  const getCategoryDisplayName = (filter) => {
    switch(filter) {
      case 'upsc': return 'UPSC Papers';
      case 'mpsc': return 'MPSC Papers';
      case 'books': return 'Books';
      case 'brochure': return 'Brochures';
      case 'capf': return 'CAPF Papers';
      default: return filter.toUpperCase();
    }
  };

  return (
    <div className="pt-20 min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100">
      <div className="max-w-6xl mx-auto p-4">
        {/* Header */}
        <div className="text-center mb-8 pt-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Study Resources Portal</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Access comprehensive study materials including exam papers, syllabus, and educational resources. 
            All files open directly in your browser for easy viewing and downloading.
          </p>
        </div>

      

        {/* Search and Filter */}
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
          <div className="flex flex-col gap-4">
            <div className="relative">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search resources, papers, or subjects..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-700"
              />
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
              <button
                onClick={() => handleFilterChange("all")}
                className={`px-4 py-2 rounded-lg font-medium transition-all ${
                  selectedFilter === "all"
                    ? 'bg-blue-600 text-white shadow-md'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                All Categories
              </button>
              {Object.keys(resources).map((category) => (
                <button
                  key={category}
                  onClick={() => handleFilterChange(category)}
                  className={`px-4 py-2 rounded-lg font-medium transition-all ${
                    selectedFilter === category
                      ? 'bg-blue-600 text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {getCategoryDisplayName(category)}
                </button>
              ))}
            </div>
            
            {selectedFilter !== "all" && (
              <div className="flex items-center gap-2 pt-2 border-t border-gray-200">
                <span className="text-sm text-gray-600">Viewing:</span>
                <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-full font-medium">
                  {getCategoryDisplayName(selectedFilter)}
                </span>
                <button
                  onClick={() => handleFilterChange("all")}
                  className="text-sm text-gray-500 hover:text-gray-700 underline ml-2"
                >
                  Clear Filter
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Resources */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
            <div className="flex items-center gap-3">
              <FolderIcon className="w-6 h-6 text-blue-600" />
              <h2 className="text-xl font-bold text-gray-800">Browse Resources</h2>
              <span className="ml-auto text-sm text-gray-500">
                {Object.keys(filteredResources).length} categories available
              </span>
            </div>
          </div>
          
          <div className="p-6">
            <div className="space-y-4">
              {Object.keys(filteredResources).length === 0 ? (
                <div className="text-center py-12">
                  <SearchIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">No resources found</h3>
                  <p className="text-gray-500 max-w-md mx-auto">
                    Try adjusting your search terms or browse all categories to find what you're looking for.
                  </p>
                  <button
                    onClick={() => {
                      setSearchTerm("");
                      setSelectedFilter("all");
                    }}
                    className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    Show All Resources
                  </button>
                </div>
              ) : (
                Object.entries(filteredResources).map(([name, data], index) => (
                  <FolderNode 
                    key={index} 
                    name={name} 
                    data={data} 
                    isRoot={true} 
                    searchTerm={searchTerm} 
                    selectedFilter={selectedFilter}
                  />
                ))
              )}
            </div>
          </div>
          
          <StatusBar />
        </div>

      
      </div>
    </div>
  );
};

export default ResourceExplorer;